import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import type { SiSolicitacaoCard } from '../siSolicitacoesPage.definitions';

interface SiSolicitacaoCardButtonProps {
  card: SiSolicitacaoCard;
  onClick: () => void;
}

/** Mesmo visual do DpRequestCard (Portal do DP), mas como botão — abre o drawer em vez de navegar. */
export function SiSolicitacaoCardButton({ card, onClick }: SiSolicitacaoCardButtonProps) {
  const { icon: Icon } = card;
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-full flex-col rounded-2xl border border-raro-gray-200 bg-white p-5 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-primary-200 hover:shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-500"
    >
      <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </span>
      <h3 className="mt-4 font-montserrat text-base font-semibold text-raro-gray-900">{card.titulo}</h3>
      <p className="mt-1 flex-1 text-sm text-raro-gray-500">{card.descricao}</p>
      {card.nota && (
        <div className="mt-4 flex w-full items-start gap-2 border-t border-dashed border-primary-200 pt-3 text-xs text-raro-gray-500">
          <CalendarDaysIcon className="mt-px h-4 w-4 shrink-0" aria-hidden="true" />
          <span>{card.nota}</span>
        </div>
      )}
    </button>
  );
}
